import AppConstants from '../common/AppConstants';
import Helper from '../common/Helper';
import { authenticationService } from '../services';
import axios from 'axios';

export function authHeader(type) {
    // return authorization header with jwt token
    // const currentUser = authenticationService.currentUserValue;
    const CancelToken = axios.CancelToken;
        let requestToken = Helper.getCookie('NBA-REQUEST-TOKEN');
    
    const source = CancelToken.source();
    if (type) {
        return { 'Content-Type': type, cancelToken: source.token, 'X-NBA-XSRF-TOKEN': requestToken }
    } else {
        return { 'Content-Type': AppConstants.HeaderTypes.APPLICATION_JSON, cancelToken: source.token, 'X-NBA-XSRF-TOKEN': requestToken };
    }
    // if ((currentUser && currentUser.token)) {
    //     return { Authorization: `Bearer ${currentUser?.token}` };
    // } else {
    //     return {};
    // }
}

// export function authHeader() {
//     // return authorization header with jwt token
//     const accessToken = localStorage.getItem("accessToken");
//     if (accessToken && accessToken !== "") {
//         //let accssTokenString = JSON.parse(JSON.stringify(accessToken)); //.replace(/"/g, "");
//         return { Authorization: "Bearer " + accessToken };
//     } else {
//         return {};
//     }
// }